const UserAssignments = require('./UserAssignments').default;

const deps = [require('ngreact').name];

module.exports = angular
  .module('bench.ui.web.userAssignments', deps)
  .directive('userAssignments', reactDirective =>
    reactDirective(UserAssignments, ['clientId', 'onClientUpdate'], {}, {}),
  );
